import React from "react";

const blinkKeyframes = `
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}`;

const styles = `
.loader-fade {
  opacity: 1;
  transition: opacity 0.7s;
}
.loader-fade.out {
  opacity: 0;
}
`;

const Loader = ({ fadeOut }) => (
  <div
    className={`loader-fade${fadeOut ? " out" : ""}`}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      background: "#fff",
      zIndex: 9999,
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%"
    }}
  >
    <style>{blinkKeyframes + styles}</style>
    <img
      src={process.env.PUBLIC_URL + "/assets/images/product/texas_automations_logo.png"}
      alt="Loading..."
      style={{
        width: 140,
        animation: "blink 2s infinite"
      }}
    />
  </div>
);

export default Loader;
